/**
 * Formate un montant en FCFA (ex: 1 000 FCFA)
 */
export function fmt(n) {
  return Math.abs(n).toLocaleString("fr-FR") + " FCFA";
}

/**
 * Calcule les frais de service (1%)
 */
export function calcFees(amount) {
  return Math.round(amount * 0.01);
}

/**
 * Génère une référence de transaction aléatoire
 */
export function genRef() {
  const rand = Math.floor(Math.random() * 9000) + 1000;
  return `#DWD-2026-${rand}`;
}

/**
 * Date/heure actuelle formatée
 */
export function nowLabel() {
  const d = new Date();
  const day = d.getDate();
  const months = [
    "jan", "fév", "mars", "avr", "mai", "juin",
    "juil", "août", "sep", "oct", "nov", "déc",
  ];
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return { date: `${day} ${months[d.getMonth()]}`, time: `${hh}:${mm}` };
}
